// extracted by mini-css-extract-plugin
module.exports = {"login_message_box":"lwg6s","close":"ec2RC"};